export default {
  "deprecation-warning": "_deprecation-warning_1b0l1h",
  "title-container": "_title-container_1b0l1h",
  "icon": "_icon_1b0l1h",
  "title": "_title_1b0l1h",
  "text": "_text_1b0l1h",
  "suggested-component": "_suggested-component_1b0l1h",
  "more-note": "_more-note_1b0l1h"
};